import React from 'react';
import { useSelector } from 'react-redux';
import { selectInvestitionen } from 'modules/investitionen/features/investitionenSlice';

/**
 * Auswahl des Investitionsorts (Bereich) fuer eine Buchung. Speist das
 * Barvermoegen des gewaehlten Ortes. Ohne angelegte Orte bleibt die Auswahl leer
 * (Hinweis) – dann ist die Buchung "nicht zugeordnet".
 */
export default function OrtAuswahl({ wert, onChange }) {
  const orte = useSelector(selectInvestitionen);

  if (orte.length === 0) {
    return (
      <p className="rounded-lg border border-dashed border-line bg-paper-soft px-3 py-2 text-sm text-ink-muted">
        Noch kein Investitionsort angelegt – lege zuerst auf der Übersicht einen an (z. B. Trade Republic).
      </p>
    );
  }

  return (
    <select
      value={wert || ''}
      onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-lg border border-line bg-paper px-3 py-2 text-ink focus:border-brand-600 focus:outline-none"
    >
      <option value="">— Investitionsort wählen —</option>
      {orte.map((o) => (
        <option key={o.uuid} value={o.uuid}>
          {o.institut}
        </option>
      ))}
    </select>
  );
}
